import { motion } from 'framer-motion';
import { Image as ImageIcon, Clock } from 'lucide-react';
import { Card } from '../ui/card';

export const GalleryWindow = () => {
  /* Commented out gallery data
  const galleryItems = [
    {
      title: 'Project Screenshot 1',
      description: 'AI Assistant Interface',
      color: 'from-primary to-accent'
    },
    {
      title: 'Project Screenshot 2',
      description: 'Analytics Dashboard',
      color: 'from-accent to-primary'
    },
    {
      title: 'Project Screenshot 3',
      description: 'E-commerce Platform',
      color: 'from-primary to-success'
    },
    {
      title: 'Project Screenshot 4',
      description: 'IoT Control Panel',
      color: 'from-success to-primary'
    },
    {
      title: 'Project Screenshot 5',
      description: 'ML Pipeline UI',
      color: 'from-accent to-success'
    },
    {
      title: 'Project Screenshot 6',
      description: 'Blockchain Explorer',
      color: 'from-primary to-accent'
    },
    {
      title: 'Project Screenshot 7',
      description: 'Mobile App Design',
      color: 'from-accent to-primary'
    },
    {
      title: 'Project Screenshot 8',
      description: 'API Documentation',
      color: 'from-primary to-success'
    }
  ];
  */

  return (
    <div className="space-y-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-4xl font-bold glow-text mb-2">Project Gallery</h1>
        <p className="text-muted-foreground">Visual showcase of my work</p>
      </motion.div>

      {/* Coming Soon Section */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="flex flex-col items-center justify-center py-20 text-center"
      >
        <div className="p-6 rounded-full bg-primary/10 mb-6">
          <Clock className="w-16 h-16 text-primary animate-pulse" />
        </div>
        <h2 className="text-5xl font-bold mb-4 glow-text">Coming Soon</h2>
        <p className="text-muted-foreground max-w-md">
          I'm currently curating the best shots of my event organizing and technical projects. 
          Stay tuned for a visual journey through my latest work!
        </p>
      </motion.div>

      {/* Gallery Grid - Commented Out
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 opacity-20 pointer-events-none">
        {galleryItems.map((item, i) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.05 }}
            className="cursor-pointer"
          >
            <Card className="tech-border overflow-hidden group">
              <div className={`aspect-square bg-gradient-to-br ${item.color} flex items-center justify-center relative overflow-hidden`}>
                <ImageIcon className="w-12 h-12 text-background/50" />
              </div>
            </Card>
          </motion.div>
        ))}
      </div>
      */}

      {/* Stats - Commented Out
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        <Card className="p-6 tech-border">
          <div className="grid grid-cols-3 gap-6 text-center">
            <div>
              <div className="text-3xl font-bold text-primary mb-1">150+</div>
              <div className="text-sm text-muted-foreground">Total Images</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-accent mb-1">42</div>
              <div className="text-sm text-muted-foreground">Projects</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-success mb-1">8</div>
              <div className="text-sm text-muted-foreground">Categories</div>
            </div>
          </div>
        </Card>
      </motion.div>
      */}
    </div>
  );
};

export default GalleryWindow;